import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { SEFSaldoFinanceiroModel } from '../../../shared/models/sef-saldo-financeiro.model';
import { SEFSaldoFinanciamentoPdf } from '../../../shared/services/documentos-pdf-imprimir/financeiro/SEF/sef-saldo-financiamento-pdf';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { SefService } from '../service/sef.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';

@Component({
  selector: 'app-sef-saldo-financiamento',
  templateUrl: './sef-saldo-financiamento.component.html',
  styleUrls: ['./sef-saldo-financiamento.component.css']
})
export class SefSaldoFinanciamentoComponent implements OnInit {

  componentes: any[] = [1];

  param: string;

  @BlockUI() blockUi: NgBlockUI;


  // 93513	6827704	MARIA DOS ANJOS SERRA

  cdCentrus: number;

  processoFormatadoTela: string;

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  sEFSaldoFinanceiroModel: Array<SEFSaldoFinanceiroModel> = new Array<SEFSaldoFinanceiroModel>();

  sEFSaldoFinanceiro = new SEFSaldoFinanceiroModel();

  vlFracaoTotal = 0;
  vlIrrfTotal = 0;
  sindicato: any;
  mensagemFooter: any;
  mensagemInformativa: string;
  mensagemSaldoInf: string;
  mensagemAcessarInf: string;


  dadosTabelaPrestacao: any[] = [];

  constructor(
    private sefService: SefService,
    private pessoaService: PessoaService,
    private toastrService: ToastrService,
    private authInterceptor: AuthInterceptor,
    private router: Router,
    private sEFSaldoFinanciamentoPdf: SEFSaldoFinanciamentoPdf,
  ) { }

  ngOnInit() {
    this._gerenciarCodigoIndentificao();

  }



  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {


        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuFinanceiro';
        }
        this.getPessoasDadosSimplificado();
      })
  }


  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getConsultaSaldoDevedor();
    } catch (error) {
      this.router.navigate([this.param])
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }



  async getConsultaSaldoDevedor() {
    this.blockUi.start();


    try {

      const sEFSaldoFinanceiro = await this.sefService.getConsultaSaldoDevedor(this.cdCentrus);
      if (sEFSaldoFinanceiro.length > 0) {




        for (const item of sEFSaldoFinanceiro) {



          if (item.cdRegulamento === '1') { continue }

          (item.tpVersaoSef === 'B'
            || item.tpVersaoSef === 'C'
            || item.tpVersaoSef === 'D') ?
            this.mensagemFooter =
            'Para liquidação antecipada de financiamento imobiliário, deverá ser solicitado a emissão de boleto bancário \n - telefones (61) 2192-1507, 2192-1408, 2192-1517 e 2192-1533 - para pagamento em qualquer agência bancária.'
            : this.mensagemFooter =
            'Saldo devedor para fins de repactuação contratual. \n Em caso de liquidação, contatar previamente a Centrus pelo telefone 0800.7040494, opção 2, ou pelo e-mail semef@centrus.org.br.';

          this.sEFSaldoFinanceiro.dsRegulamento = item.dsRegulamento;

          if (item.vlSaldoDevedor > 0) {
            if (item.dsOcorrencia === 'ACAO JUDICIAL CONTRA') {
              this.mensagemInformativa = `Contrato com ação judicial favor entrar em contato com a Centrus`;
            } else {

              this.sEFSaldoFinanceiro.dtSlado = item.dtSlado;
              this.sEFSaldoFinanceiro.vlSaldoDevedor = item.vlSaldoDevedor;
              this.sEFSaldoFinanceiro.vlPrestAtraso = item.vlPrestAtraso;


              if ((item.cdRegulamento === '7'
                || item.cdRegulamento === '8'
                || item.cdRegulamento === '9')
                && (item.tpVersao !== '12')) {

                if (item.cdRegulamento === '9'
                  && item.tpVersaoSef === 'C') {
                  this.sEFSaldoFinanceiro.vlSaldoTotal = item.vlSaldoTotal;
                } else {
                  this.mensagemAcessarInf = 'Clique aqui para verificar o valor para liquidação';
                  const href = '/repac/repac/SimulaLiquidacaoServlet?matricula=<%=usuario%>&opcao=<%=opcao%>';
                }
              } else {
                this.sEFSaldoFinanceiro.vlSaldoTotal = item.vlSaldoTotal;
              }
            }
          } else {
            this.mensagemSaldoInf = 'Saldo Indisponível';
          }

          if (item.dsOcorrencia.trim() === ''
            && item.cdRegulamento === '7') {

            this.mensagemSaldoInf = 'Saldo devedor provisório sujeito a alteração';
          }


          if (Number(item.nrPrazo) > 0) {
            this.sEFSaldoFinanceiro.nrUltPrest = item.nrUltPrest
            this.sEFSaldoFinanceiro.vlPrincPrest = item.vlPrincPrest
            this.sEFSaldoFinanceiro.vlJurosPrest = item.vlJurosPrest
            this.sEFSaldoFinanceiro.vlSeguroPrest = item.vlSeguroPrest
            this.sEFSaldoFinanceiro.vlTxAdmPrest = item.vlTxAdmPrest
            this.sEFSaldoFinanceiro.vlUltPrest = item.vlUltPrest

            this.dadosTabelaPrestacao.push(
              { dp: '', descricao: 'Principal (+) :', valor: this.sEFSaldoFinanceiro.vlPrincPrest },
              { dp: '', descricao: 'Juros (+) :', valor: this.sEFSaldoFinanceiro.vlJurosPrest },
              { dp: '', descricao: 'Seguro (+) :', valor: this.sEFSaldoFinanceiro.vlSeguroPrest },
              { dp: '', descricao: 'Tx. Administração (+) :', valor: this.sEFSaldoFinanceiro.vlTxAdmPrest },
              { dp: '', descricao: 'Prestação :', valor: this.sEFSaldoFinanceiro.vlUltPrest }
            )
          }

          this.sEFSaldoFinanceiroModel.push(this.sEFSaldoFinanceiro);
        }
      }

    } catch (error) {
      this.router.navigate([this.param])
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    } finally {
      this.blockUi.stop();
    }
  }




  imprimirPagina() {
    this.sEFSaldoFinanciamentoPdf.funcionarios(
      this.pessoaDadosSimplicadosModel,
      this.sEFSaldoFinanceiroModel,
      this.dadosTabelaPrestacao,
      this.mensagemFooter,
      this.mensagemInformativa,
      this.mensagemSaldoInf,
      this.mensagemAcessarInf);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/sef/sef-saldo-financiamento/sef-saldo-financiamento.component.ts